export const pluralize = (w: string, n: number, prefix: boolean = false) => {
  return `${prefix ? `${n} ` : ''}${w}${n != 1 ? 's' : ''}`
}
